import { useState, useEffect, useMemo } from "preact/hooks";

const MOBILE_BREAKPOINT = 992;

export type UseIsMobileOptions = {
  breakpoint?: number;
  compare?: "lt" | "gte";
};

export function useIsMobile(arg?: number | UseIsMobileOptions) {
  const opts = useMemo<Required<UseIsMobileOptions>>(() => {
    if (typeof arg === "number" || arg == null) {
      return {
        breakpoint: (arg as number) ?? MOBILE_BREAKPOINT,
        compare: "lt",
      };
    }
    return {
      breakpoint: arg.breakpoint ?? MOBILE_BREAKPOINT,
      compare: arg.compare ?? "lt",
    };
  }, [arg]);

  const [state, setState] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return opts.compare === "lt"
      ? window.innerWidth < opts.breakpoint
      : window.innerWidth >= opts.breakpoint;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    const handleResize = () => {
      const next =
        opts.compare === "lt"
          ? window.innerWidth < opts.breakpoint
          : window.innerWidth >= opts.breakpoint;
      setState(next);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [opts.breakpoint, opts.compare]);

  return state;
}
